<div class="tw-py-[0.3125rem]">
  @if (selectFlightState.selectedFlight(); as data) {
    <ng-container
      [ngTemplateOutlet]="content"
      [ngTemplateOutletContext]="{
        roundTrip: false,
        segments: data.flights[0].segments,
      }"
    ></ng-container>
  }

  @if (
    selectFlightState.roundTrip() && selectFlightState.selectedRoundTripFlight()
  ) {
    @if (selectFlightState.selectedRoundTripFlight(); as data) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          roundTrip: true,
          segments: data.flights[0].segments,
        }"
      ></ng-container>
    }
  }

  @if (
    selectFlightState.showSmartCombo() && selectFlightState.selectedSmartCombo()
  ) {
    @if (selectFlightState.selectedSmartCombo(); as data) {
      @for (flight of data.flights; track $index) {
        <ng-container
          [ngTemplateOutlet]="content"
          [ngTemplateOutletContext]="{
            roundTrip: $index > 0,
            segments: flight.segments,
          }"
        ></ng-container>
      }
    }
  }
</div>

<ng-template #content let-roundTrip="roundTrip" let-segments="segments">
  <div class="tw-mb-2.5">
    <span
      class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-secondary"
    >
      {{ roundTrip === false ? "1. Chiều đi:" : "2. Chiều về" }}
    </span>
    <div class="tw-w-full tw-overflow-x-auto">
      <table class="tw-w-full tw-text-sm">
        <thead class="tw-bg-secondary tw-text-secondary-content">
          <tr class="tw-border tw-border-secondary">
            <th class="tw-w-[30%] tw-border-r tw-border-current tw-p-1">
              Thời gian
            </th>
            <th class="tw-border-r tw-border-current tw-p-1">Sân bay</th>
            <th class="tw-border-r tw-p-1">Chuyến bay</th>
          </tr>
        </thead>
        <tbody>
          @for (segment of segments; track $index) {
            <tr class="tw-border-b tw-border-secondary">
              <td
                class="tw-border-l tw-border-secondary tw-p-1 last:tw-border-r"
              >
                <p>{{ segment.startDate | date: "HH:mm" }}</p>
                <p>{{ segment.startDate | date: "EEEE, dd/MM/yyyy" }}</p>
                <p>{{ segment.endDate | date: "HH:mm" }}</p>
                <p>{{ segment.endDate | date: "EEEE, dd/MM/yyyy" }}</p>
              </td>
              <td
                class="tw-border-l tw-border-secondary tw-p-1 last:tw-border-r"
              >
                <p>
                  Cất cánh: {{ segment.startPoint }}
                  @if (segment.startTerminal) {
                    ({{ segment.startTerminal }})
                  }
                </p>
                <p>{{ segment.startPointName }}</p>
                <p>
                  Hạ cánh: {{ segment.endPoint }}
                  @if (segment.endTerminal) {
                    ({{ segment.endTerminal }})
                  }
                </p>
                <p>{{ segment.endPointName }}</p>
              </td>
              <td
                class="tw-border-l tw-border-secondary tw-p-1 last:tw-border-r"
              >
                <!-- <img
                  class="tw-h-5 tw-max-w-24 tw-object-contain"
                  [src]="segment.airline | airlineImg: { flightCode: segment.flightCode }"
                /> -->
                <p>{{ segment.airlineName }} ({{ segment.airline }})</p>
                <p>Máy bay: {{ segment.flightNo }}</p>
                <p>Số hiệu: {{ segment.flightCode }}</p>
                <p>Hạng ghế: {{ segment.fareClass }}</p>
                <p>Thời gian: {{ segment.flightTime | flightTime }}</p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
